import { useState } from "react";
import { Facebook, MessageCircle, Link2, Check, Share2, Download } from "lucide-react";

const TEXT = "Earth Angel — Queen Boyce, The Chosen Star Seed Healer and Teacher. Transmute pain into purpose.";

const XIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82H1.67l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64z" />
  </svg>
);

const btn = "glass card-hover rounded-full w-11 h-11 inline-flex items-center justify-center text-gold hover:text-[#f1d57a]";

export const ShareBar = () => {
  const [copied, setCopied] = useState(false);
  const url = window.location.origin;
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(TEXT);
  const links = [
    { name: "facebook", label: "Share on Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, icon: <Facebook size={16} /> },
    { name: "x", label: "Share on X", href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, icon: <XIcon /> },
    { name: "whatsapp", label: "Share on WhatsApp", href: `https://wa.me/?text=${t}%20${u}`, icon: <MessageCircle size={16} /> },
  ];

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div data-testid="share-bar">
      <p className="eyebrow">Share the light</p>
      <div className="flex flex-wrap items-center gap-3 mt-4">
        {navigator.share && (
          <button className={btn} aria-label="Share" onClick={() => navigator.share({ title: "Earth Angel", text: TEXT, url }).catch(() => {})} data-testid="share-native-btn"><Share2 size={16} /></button>
        )}
        {links.map((l) => (
          <a key={l.name} href={l.href} target="_blank" rel="noopener noreferrer" aria-label={l.label} className={btn} data-testid={`share-${l.name}-btn`}>{l.icon}</a>
        ))}
        <button className={btn} aria-label="Copy link" onClick={copy} data-testid="share-copy-btn">{copied ? <Check size={16} /> : <Link2 size={16} />}</button>
        <a href="/share-square.jpg" download="earth-angel.jpg" className="btn-ghost !py-2.5 !px-5 !text-xs inline-flex items-center gap-2" data-testid="share-download-btn"><Download size={14} /> Share picture</a>
        <a href="/share-story.jpg" download="earth-angel-story.jpg" className="btn-ghost !py-2.5 !px-5 !text-xs inline-flex items-center gap-2" data-testid="share-story-download-btn"><Download size={14} /> Story picture</a>
      </div>
      {copied && <p className="text-xs text-[#f1d57a] mt-2" data-testid="share-copied-msg">Link copied</p>}
    </div>
  );
};
